// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VT-1","toggleWrap":"styles_toggleWrap__23IzX","content":"styles_content__BTCrz","selectAreaCode":"styles_selectAreaCode__U4Eeb"};